import script from "./FinishView.vue?vue&type=script&setup=true&lang=js"
export * from "./FinishView.vue?vue&type=script&setup=true&lang=js"

import "./FinishView.vue?vue&type=style&index=0&id=6dc1e320&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dc1e320"]])

export default __exports__